export default __webpack_public_path__ + "content/media/Black-IcoFacebook.729046ee.svg";